export const formatDate = (inputDate: string | Date | null): string => {
  if (!inputDate) return "-";
  const date = new Date(inputDate);
  if (isNaN(date.getTime())) return "-";
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear().toString().slice(-2);
  return `${day}/${month}/${year}`;
};